/** Last known pointer position for focus scoring (shared with cursor tracker). */
export type PointerPoint = {
  x: number;
  y: number;
  at: number;
};

let lastPointer: PointerPoint | null = null;

export function setLastPointerPosition(x: number, y: number): void {
  lastPointer = { x, y, at: Date.now() };
}

export function getLastPointerPosition(): PointerPoint | null {
  return lastPointer;
}

export function clearLastPointerPosition(): void {
  lastPointer = null;
}
